export function removeLoadingSkeleton() {
  let elDesktop = document.getElementById('loading-skeleton-desktop')
  elDesktop?.remove()
  elDesktop = null
  let elMobile = document.getElementById('loading-skeleton-mobile')
  elMobile?.remove()
  elMobile = null
}
